import React from 'react';

import './section.scss';

interface SectionProps {
  children?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  heading?: React.ReactNode;
  id?: string;
  intro?: React.ReactNode;
  isFullWidth?: boolean;
  showDivider?: boolean;
  styleName?: string;
}

export const Section = React.forwardRef<HTMLElement, SectionProps>(
  function Section(props, ref) {
    const {
      children,
      className,
      'data-testid': dataTestId,
      heading,
      id,
      intro,
      isFullWidth = false,
      showDivider = false
    } = props;

    return (
      <section
        className={`${className || ''} section`}
        data-testid={dataTestId}
        id={id}
        ref={ref}
        styleName={showDivider ? 'container-w-divider' : 'container'}
      >
        {heading && <h3 styleName="heading">{heading}</h3>}

        {intro && <div styleName="intro">{intro}</div>}

        <div
          className="section__content"
          data-testid="section-content"
          styleName={isFullWidth ? 'content-fullwidth' : 'content'}
        >
          {children}
        </div>
      </section>
    );
  }
);

export default Section;
